import data from '@emoji-mart/data';
import { Picker } from 'emoji-mart';
import { createElement, FC, useEffect, useRef } from 'react';

interface EmojiSelectorProps {
	command: (...args: any[]) => void;
}

// NOTE: This is copied directly from the source code of @emoji-mart/react https://github.com/missive/emoji-mart/blob/main/packages/emoji-mart-react/react.tsx
// It is exported as a default export and there are issues with Webpack incorrctly resolving the import. Additionally, I made a manual change to pull a single
// Picker component from the window's customElements in case multiple versions of the emoji-mart pacakge are bundled.
function EmojiPicker(props: any) {
	const ref = useRef(null);
	const instance = useRef<any>(null);

	if (instance.current) {
		instance.current.update(props);
	}

	useEffect(() => {
		let Component: any = Picker;

		// This is where we need to check if a Picker from a different version of emoji-mart is already loaded
		if (customElements.get('em-emoji-picker')) {
			Component = customElements.get('em-emoji-picker');
		}

		instance.current = new Component({ ...props, ref });

		return () => {
			instance.current = null;
		};
	}, []);

	return createElement('div', { ref });
}

export const EmojiSelector: FC<EmojiSelectorProps> = ({ command }) => {
	const handleSelect = ({ native }: any) => {
		command({ id: native });
	};

	return <EmojiPicker autoFocus data={data} onEmojiSelect={handleSelect} />;
};
